import {useTranslation} from "react-i18next";
import "moment-timezone";
import Moment from "moment/moment";
import DurationDisplay from "components/datestimes/DurationDisplay";

const TableRoutes = ({items, itemsShown, setItemsShown, buttonsTB, setButtonsTB}) => {
    const {t: _Tc} = useTranslation("choices");
    const {t: _Tt} = useTranslation("tables");
    const {t: _tT} = useTranslation("tags");
    const stickyHeaderStyle = {
        position: "sticky",
        top: "168px",
        backgroundColor: "white",
    };
    const onClickRow = (e) => {
        let checkbox = e.target;
        let idx = parseInt(checkbox.value);

        if (checkbox.checked) {
            items.current.chosen.push(idx);
        } else {
            items.current.chosen = items.current.chosen.filter((idx_) => idx_ !== idx);
        }
        let buttons = {...buttonsTB};
        buttons.edit.disabled = items.current.chosen.length === 0;
        setButtonsTB(buttons);
    };

    return (
        <table className="table table-striped">
            <thead>
                <tr>
                    <th className="sticky-top border-bottom-sticky" key="-1" style={{width: "30px", ...stickyHeaderStyle}}>
                        <input className="form-check-input" type="checkbox" value="all" />
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "130px", ...stickyHeaderStyle}}>
                        {_Tt("common.created")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={stickyHeaderStyle}>
                        {_Tt("containers.name")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "100px", ...stickyHeaderStyle}}>
                        {_Tt("users.driver")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "100px", ...stickyHeaderStyle}}>
                        {_Tt("programming.starts")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "100px", ...stickyHeaderStyle}}>
                        {_Tt("programming.ends")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "100px", ...stickyHeaderStyle}}>
                        {_Tt("common.type")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "100px", ...stickyHeaderStyle}}>
                        {_Tt("common.download")}
                    </th>
                    <th className="sticky-top border-bottom-sticky" style={{width: "100px", ...stickyHeaderStyle}}>
                        {_Tt("containers.waste_type")}
                    </th>
                    <th
                        className="sticky-top border-bottom-sticky"
                        style={{width: "70px", textAlign: "center", ...stickyHeaderStyle}}>
                        {_Tt("programming.stops")}
                    </th>
                </tr>
            </thead>
            <tbody>
                {itemsShown.map((item, index) => (
                    <tr key={index} data-idx={index}>
                        <td>
                            <input type="checkbox" value={index} onChange={onClickRow} />
                        </td>
                        <td>{Moment(item.created_at).format("DD-MM-YYYY HH:mm")}</td>
                        <td>{item.name}</td>
                        <td>{item.driver_email}</td>
                        <td>
                            <DurationDisplay seconds={item.hour_start} format="HH:mm" />
                        </td>
                        <td>
                            <DurationDisplay seconds={item.hour_end} format="HH:mm" />
                        </td>
                        <td>{_Tc("route_types." + item.type)}</td>
                        <td>{_Tc("downloads." + item.download_type)}</td>
                        <td>{_Tc("wastes." + item.waste_type)}</td>
                        <td className="text-center">{item.actives}</td>
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TableRoutes;
